import * as React from "react"
import { Link } from "gatsby"
import CartIcon from "../icons/cart"
import { cartButton, badge } from "./cart-button.module.css"

export function CartButton({ quantity }) {
  return (
    <button
      aria-label={`Shopping Cart with ${quantity} items`}
      className={cartButton}
    >
      {/* <CartIcon /> */}
      <svg
      className="flex-shrink-0 h-6 w-6 md:h-6 md:w-6 fill-gray-500 hover:fill-ec-sea"
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 24 24"
        width="24"
        height="24"
      >
        <path fill="none" d="M0 0h24v24H0z" />
        <path d="M7 8V6a5 5 0 1 1 10 0v2h3a1 1 0 0 1 1 1v12a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1V9a1 1 0 0 1 1-1h3zm0 2H5v10h14V10h-2v2h-2v-2H9v2H7v-2zm2-2h6V6a3 3 0 0 0-6 0v2z" />
      </svg>
      {quantity > 0 && <div className={badge}>{quantity}</div>}
    </button>
  )
}
